import {
    createSlice,
    createAsyncThunk
} from '@reduxjs/toolkit'
import api from '../../api/api'

export const place_order = createAsyncThunk(
    'order/place_order',
    async (info, { rejectWithValue }) => {
        try {
            const { data } = await api.post('/home/order/place-order', info)
            return data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const get_orders = createAsyncThunk(
    'order/get_orders',
    async ({ status, customerId }, { rejectWithValue }) => {
        try {
            const { data } = await api.get(`/home/customer/gat-orders/${customerId}/${status}`)
            return data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const get_order = createAsyncThunk(
    'order/get_order',
    async (orderNumber, { rejectWithValue }) => {
        try {
            const { data } = await api.get(`/home/customer/gat-order/${orderNumber}`)
            return data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const cancel_order = createAsyncThunk(
    'order/cancel_order',
    async ({ orderNumber }, { rejectWithValue }) => {
        try {
            const { data } = await api.put(`/order/cancel-order/${orderNumber}`)
            return data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const get_guest_orders = createAsyncThunk(
    'order/get_guest_orders',
    async ({ email, phone }, { rejectWithValue }) => {
        try {
            const params = new URLSearchParams()
            if (email) params.append('email', email)
            if (phone) params.append('phone', phone)
            
            const url = `/home/customer/guest-orders?${params.toString()}`
            
            const { data } = await api.get(url)
            return data
        } catch (error) {
            console.error('Guest orders API error:', error.response?.data || error.message)
            return rejectWithValue(error.response?.data || { message: error.message })
        }
    }
)

const orderSlice = createSlice({
    name: 'order',
    initialState: {
        myOrders: [],
        myOrder: {},
        successMessage: '',
        errorMessage: '',
        loading: false,
        guestCustomer: null
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = ''
            state.successMessage = ''
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(get_orders.pending, (state) => {
                state.loading = true
            })
            .addCase(get_orders.fulfilled, (state, { payload }) => {
                state.loading = false
                state.myOrders = payload.orders
            })
            .addCase(get_orders.rejected, (state, { payload }) => {
                state.loading = false
                state.errorMessage = payload.message
            })
            .addCase(get_order.pending, (state) => {
                state.loading = true
            })
            .addCase(get_order.fulfilled, (state, { payload }) => {
                state.loading = false
                state.myOrder = payload.order || {}
            })
            .addCase(get_order.rejected, (state, { payload }) => {
                state.loading = false
                state.errorMessage = payload?.message || 'Failed to fetch order'
                state.myOrder = {}
            })
            .addCase(place_order.pending, (state) => {
                state.loading = true
            })
            .addCase(place_order.fulfilled, (state, { payload }) => {
                state.loading = false
                state.myOrder = payload
            })
            .addCase(place_order.rejected, (state, { payload }) => {
                state.loading = false
                state.errorMessage = payload?.message || 'Failed to place order'
            })
            .addCase(cancel_order.pending, (state) => {
                state.loading = true
            })
            .addCase(cancel_order.fulfilled, (state, { payload }) => {
                state.loading = false
                state.successMessage = payload.message
                // Update the order status in myOrders array
                const index = state.myOrders.findIndex(order => order.orderNumber === payload.order.orderNumber)
                if (index !== -1) {
                    state.myOrders[index] = payload.order
                }
                // Update myOrder if it's the cancelled order
                if (state.myOrder.orderNumber === payload.order.orderNumber) {
                    state.myOrder = payload.order
                }
            })
            .addCase(cancel_order.rejected, (state, { payload }) => {
                state.loading = false
                state.errorMessage = payload?.message || 'Failed to cancel order'
            })
            .addCase(get_guest_orders.pending, (state) => {
                state.loading = true
            })
            .addCase(get_guest_orders.fulfilled, (state, { payload }) => {
                        state.loading = false
        state.myOrders = payload.orders || []
        state.guestCustomer = payload.customer || null
            })
            .addCase(get_guest_orders.rejected, (state, { payload }) => {
                state.loading = false
                state.errorMessage = payload?.message || 'Failed to fetch guest orders'
                state.myOrders = []
                state.guestCustomer = null
            })
    }
})

export const { messageClear } = orderSlice.actions
export default orderSlice.reducer